import styled from "styled-components/macro";

import { space, breakpoint } from "shared/styles/constants";

export const StyledMenuToggle = styled.span`
  flex: 0 0 auto;

  align-items: center;
  display: none;

  > * + * {
    margin-left: ${space.xs};
  }

  ${breakpoint("m", "down")} {
    display: flex;
  }
`;
